import { ExIcon } from '@boomi/exosphere';
import { newGuid } from './utils';

interface Props {
    text: string;
}

const TextWithArrows = ({ text }: Props) => {
    const arrowRegex = RegExp('(-+>)');
    const textArray = text.split(arrowRegex);
    const parsedText = textArray.map((sub) => {
        if (sub.match(arrowRegex)) {
            return (
                <ExIcon
                    key={newGuid()}
                    className="text-with-arrows-icon"
                    icon="Right arrow"
                    slot="suffix"
                    hide-browser-tooltip
                />
            );
        }
        return sub;
    });

    // Returning just parsedText makes React complain about child elements not having keys.
    return <>{...parsedText}</>;
};

export default TextWithArrows;
